import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MenuItem } from '../../lib/sofbox/models/menu-item';
import AppMenuConfig from '../config/menu.config.json';
import MobileAppMenuConfig from '../config/mobile.app.menu.config.json';
import { AuthenticationService } from './authentication.service';
import { map } from 'rxjs/operators';
import { CurrentUser, OrganisationUser } from '../models/auth-user';
import { LoggedInUser } from './managerial-operations.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(
    private authService: AuthenticationService,
  ) { }

  getMenuList(): Observable<MenuItem[]> {
    return this.authService.getCurretUser().pipe(
      map((userInfo) => {
        const isMobileOrg = 'mobileOrg' in userInfo 
        ? (userInfo as any).mobileOrg === 1
        : false;
        // 1) Extract org code from whichever user type
        let orgCode = '';
        if (userInfo instanceof OrganisationUser) {
          orgCode = userInfo.organisationCode;
        } else if (userInfo instanceof LoggedInUser) {
          orgCode = (userInfo as any).organisationCode || '';
        } else if (userInfo instanceof CurrentUser) {
          orgCode = (userInfo as any).organisationCode || '';
        }

        const configData = AppMenuConfig.data;

        // 3) Determine roleId
        let roleId = 0;
        if (userInfo instanceof CurrentUser) {
          roleId = userInfo.UserDetails.roleId;
        } else if (userInfo instanceof LoggedInUser) {
          roleId = userInfo.roleId;
        }else if (userInfo instanceof OrganisationUser) {
          roleId = userInfo.roleId;
        }
        // 4) Filter menu items by role
        return (configData as Array<MenuItem>).filter(menuItem =>{
          if (menuItem.roles.includes(roleId)){
            return true;
          }
          return false;
        });
      })
    );
  }
}
